export default ['TTD', 'USD', 'BBD', 'JMD'];
